import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useMultiOrderedResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useMultiOrderedResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedArtifactResource,
    IndirectlyVersionedArtifactResourceSchema,
} from '../../../resource-base/artifactResourceTypes';

export enum ContentSectionPropertyValidation {
    TITLE = 'TITLE',
}

export const ContentSectionResourceSchema = IndirectlyVersionedArtifactResourceSchema.extend({
    resourceType: z.literal(ResourceType.CONTENT_SECTION).default(ResourceType.CONTENT_SECTION),
    title: z.string().nullable(),
});
export const ContentSectionMutationResourceSchema = getMutationSchema(ContentSectionResourceSchema);

export type ContentSectionResource = z.infer<typeof ContentSectionResourceSchema>;

export const defaultContentSectionResource: ContentSectionResource = {
    ...defaultIndirectlyVersionedArtifactResource,
    resourceType: ResourceType.CONTENT_SECTION,
    title: null,
};

export function useContentSectionActions() {
    return {
        ...useMultiOrderedResourceSingleParentedResourceAdapterActions(
            'content-section',
            ResourceType.CONTENT_SECTION,
            ContentSectionResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter(
            'content-section',
            ResourceType.CONTENT_SECTION,
            ContentSectionResourceSchema
        ),
    };
}
